@layer chart {
  .tooltip {
    all: unset;
    white-space: nowrap;
  }
}
